import React from "react";
import { Link } from "react-router-dom";
import "../../styles/Empresa.css";
import {
    breadcrumBandeja, breadcrumLotes, breadcrumAdmin, breadcrumReportes,
    breadcrumConfig, verificarRol, breadcrumEstructura,
    breadcrumTramites, idEmpresa, URL, gestionTramites,
    breadcrumMisNotificaciones, gestionNotificacion,
    breadcrumLegajos
} from "../../constans/constants";

class Navbar extends React.Component {

    getBotonAccion = (seccion) => {
        const rolesData = JSON.parse(localStorage.getItem("roles"));
        switch (seccion) {
            case 'Lotes':
                return {
                    type: 'link',
                    to: '/lotes/generar',
                    texto: 'Generar Lote'
                };
            case 'Bandeja':
                
                if(verificarRol(rolesData, gestionTramites))
                    return {
                        type: 'link',
                        to: '/tramites/generar',
                        texto: 'Iniciar Solicitud'
                    };
                else
                    return null;
            case 'Reportes':
                return {
                    type: 'button',
                    onClick: this.descargarReporteRecibosXls,
                    texto: 'Descargar XLS'
                };
            case 'Notificaciones':
                
                if(verificarRol(rolesData, gestionNotificacion))
                return {
                    type: 'link',
                    to: '/notificaciones/crear-notificacion',
                    texto: 'Crear Notificación'
                };
            default:
                return null;
        }
    }

    descargarReporteRecibosXls = () => {
        window.location.href = URL + "reportes/recibos/usuarios/descargar/xls?idEmpresa=" + idEmpresa();
    }

    setActiveClass = (actual, url, rol, rolesData) => {
        if (!verificarRol(rolesData, rol)) return 'tray__item d-none';
        if (actual.includes(url)) return 'tray__item active';
        return 'tray__item';
    }

    getItemsMenu = (seccionActual) => {
        switch (seccionActual) {
            case 'Lotes': return breadcrumLotes;
            case 'Bandeja': return breadcrumBandeja;
            case 'Configuración': return breadcrumConfig;
            case 'Estructura': return breadcrumEstructura;
            case 'Administración': return breadcrumAdmin();
            case 'Reportes': return breadcrumReportes;
            case 'Tramites': return breadcrumTramites;
            case 'Notificaciones': return breadcrumMisNotificaciones;
            case 'Legajos': return breadcrumLegajos;
            default: return [];
        }
    }

    render() {
        const itemsMenu = this.getItemsMenu(this.props.seccionActual);
        const rolesData = JSON.parse(localStorage.getItem("roles"));
        const botonAccion = this.getBotonAccion(this.props.seccionActual);

        return (
            <div className="scroll-content">
                <div className="sidebar-tray__content">
                    {botonAccion && (
                        <div className="sidebar-nav__action" style={{ paddingBottom: '1rem' }}>
                            {botonAccion.type === 'link' ? (
                                <Link to={botonAccion.to} className="btn-medium btn-primary">
                                    <span className="material-symbols-outlined">upload_file</span> {botonAccion.texto}
                                </Link>
                            ) : (
                                <button onClick={botonAccion.onClick} className="btn-medium btn-primary">
                                    <span className="material-symbols-outlined">upload_file</span> {botonAccion.texto}
                                </button>
                            )}
                        </div>
                    )}
                    <span className="sidebar-title"> {this.props.seccionActual}</span>
                    {
                        itemsMenu.map((item, index) => (
                            <li
                                key={index}
                                className={
                                    this.setActiveClass(this.props.menuActual, item.url, item.rol, rolesData) +
                                    (item.news ? ' news' : '')
                                }
                            >
                               { verificarRol(rolesData, item.rol)?<Link to={{ pathname: item.url }} className="tray__link">
                                    <div className="icon">
                                        {item.icon}
                                    </div>
                                    <span className="tray__txt">{item.nombre}</span>
                                    {item.numero !== undefined && (
                                        <span className="tray__number">{item.numero}</span>
                                    )}
                                </Link>:null}
                            </li>
                        ))
                    }
                </div>
            </div>
        );
    }
}

export default Navbar;